import Component from '@glimmer/component';
import { service } from '@ember/service';
import type RfiService from 'scaleflow/services/rfi';

export interface RfiNoticeSignature {
  Element: HTMLDivElement;
  Args: object;
}

/** Shows the last load, upload or delete failure, if any. */
export default class RfiNotice extends Component<RfiNoticeSignature> {
  @service declare rfi: RfiService;

  <template>
    {{#if this.rfi.errorMessage}}
      <div
        role="alert"
        class="rounded-lg border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-800"
        ...attributes
      >{{this.rfi.errorMessage}}</div>
    {{/if}}
  </template>
}
